import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';
import styled from 'styled-components';

import { Field, FieldType, Subheading } from '@treams/treams-ui';

import EmployeesDepartmentFilter from './EmployeesDepartmentFilter';
import EmployeesStatusFilter from './EmployeesStatusFilter';
import EmployeesCycleFilter from './filters/EmployeesCycleFilter';
import EmployeesExternalFilter from './filters/EmployeesExternalFilter';
import EmployeesJobFilter from './filters/EmployeesJobFilter';

const SearchField = styled(Field)`
	border-radius: 20px;
	height: 40px;
`;

export default function EmployeesFilters(props: { status?: boolean }) {
	const { t } = useTranslation();

	return (
		<Box>
			<Box marginTop={3}>
				<SearchField name="query" type={FieldType.Text} placeholder="Search (name, email)" />
			</Box>
			<Box>
				<Subheading>{t('employees.filters.meta.title')}</Subheading>
				<EmployeesDepartmentFilter />
				{props.status !== false && <EmployeesStatusFilter />}
				{props.status !== false && <EmployeesExternalFilter />}
				<EmployeesCycleFilter />
				<EmployeesJobFilter />
			</Box>
		</Box>
	);
}
